import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-refresh-icon',
  template: `
    <svg 
      [class.disabled]="disabled"
      class="refresh-icon" 
      xmlns="http://www.w3.org/2000/svg"
      width="20" 
      height="20" 
      viewBox="0 0 30 30" 
      fill="none">
      <g class="refresh-group">
        <path 
          class="arrow-path"
          d="M 15 3 C 12.053086 3 9.3294211 4.0897803 7.2558594 5.8359375 A 1.0001 1.0001 0 1 0 8.5449219 7.3652344 C 10.27136 5.9113916 12.546914 5 15 5 C 20.226608 5 24.456683 8.9136179 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.441216 7.8348596 21.297943 3 15 3 z M 4.3007812 9 L 0.30078125 15 L 3 15 C 3 21.635519 8.3644809 27 15 27 C 17.946914 27 20.670579 25.91022 22.744141 24.164062 A 1.0001 1.0001 0 1 0 21.455078 22.634766 C 19.72864 24.088608 17.453086 25 15 25 C 9.4355191 25 5 20.564481 5 15 L 8.3007812 15 L 4.3007812 9 z"
          fill="currentColor"
        />
      </g>
    </svg>
  `,
  styles: [`
    .refresh-icon {
      --color-1: #3b82f6;  /* Blue */
      --color-2: #10b981;  /* Green */
      --color-3: #8b5cf6;  /* Purple */
      --color-4: #f59e0b;  /* Orange */
      --color-5: #ef4444;  /* Red */
      
      .refresh-group {
        transform-origin: center;
        animation: spin 2s linear infinite paused;
      }

      &:not(.disabled) .refresh-group {
        animation-play-state: running;
      }
      
      .arrow-path {
        animation: colorChange 10s infinite;
      }

      &.disabled {
        .arrow-path {
          animation: none;
          fill: currentColor;
          opacity: 0.6;
        }
      }
    }

    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    @keyframes colorChange {
      0%, 100% { 
        fill: var(--color-1);
      }
      20% { 
        fill: var(--color-2);
      }
      40% { 
        fill: var(--color-3);
      }
      60% { 
        fill: var(--color-4);
      }
      80% { 
        fill: var(--color-5);
      }
    }
  `]
})
export class RefreshIconComponent {
  @Input() disabled: boolean = false;
} 